import { SvgIcon, SvgIconProps } from "@mui/material";

export const MicrosoftIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 52 52">
      <path fill="#F1511B" d="M24.713 24.713H0V0h24.713v24.713Z" />
      <path fill="#80CC28" d="M52.008 24.713H27.295V0h24.713v24.713Z" />
      <path fill="#00ADEF" d="M24.713 52H0V27.287h24.713V52Z" />
      <path fill="#FBBC09" d="M52.008 52H27.295V27.287h24.713V52Z" />
    </svg>
  </SvgIcon>
);
